<template>
  <el-dialog
    title="选择内容链接"
    :visible.sync="visible"
    width="840px"
    append-to-body
    :close-on-press-escape="false">
    <div class="content-wrap">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane
          label="平台内容"
          name="0">
          <message-info
            v-if="activeName === '0'"
            :linkType="0"
            :contentTypes="[0]"
            @select="select" />
        </el-tab-pane>
        <el-tab-pane
          label="政策资讯"
          name="4">
          <news-info
            v-if="activeName === '4'"
            :linkType="200"
            @select="select" />
        </el-tab-pane>
        <el-tab-pane
          label="产品白名单"
          name="7">
          <goods-info
            v-if="activeName === '7'"
            :linkType="220"
            @select="select" />
        </el-tab-pane>
        <el-tab-pane
          label="人员白名单"
          name="5">
          <expert-info
            v-if="activeName === '5'"
            :linkType="230"
            @select="select" />
        </el-tab-pane>
        <el-tab-pane
          label="合作企业"
          name="2">
          <vendor-info
            v-if="activeName === '2'"
            :linkType="240"
            @select="select" />
        </el-tab-pane>
        <el-tab-pane
          label="合作机构"
          name="1">
          <org-info
            v-if="activeName === '1'"
            :linkType="250"
            @select="select" />
        </el-tab-pane>
        <el-tab-pane
          label="合作服务"
          name="3">
          <service-info
            v-if="activeName === '3'"
            :linkType="260"
            @select="select" />
        </el-tab-pane>

        <el-tab-pane
          label="其他链接"
          name="6">
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:201, link: null, title: '资讯中心'})">资讯中心</el-tag>
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:221, link: null, title: '产品中心'})">产品中心</el-tag>
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:231, link: null, title: '人员中心'})">人员中心</el-tag>
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:241, link: null, title: '企业中心'})">企业中心</el-tag>
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:251, link: null, title: '机构中心'})">机构中心</el-tag>
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:261, link: null, title: '服务中心'})">服务中心</el-tag>
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:271, link: null, title: '金盾调解'})">金盾调解</el-tag>
        </el-tab-pane>
      </el-tabs>
    </div>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">关 闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import ExpertInfo from './busi-content/expert-info.vue'
import GoodsInfo from './busi-content/goods-info.vue'
import MessageInfo from './busi-content/message-info.vue'
import NewsInfo from './busi-content/news-info.vue'
import OrgInfo from './busi-content/org-info.vue'
import ServiceInfo from './busi-content/service-info.vue'
import VendorInfo from './busi-content/vendor-info.vue'
export default {
  name: 'ContentSelectModal',
  components: { MessageInfo, NewsInfo, OrgInfo, ServiceInfo, VendorInfo, GoodsInfo, ExpertInfo },
  data() {
    return {
      loading: false,
      visible: false,
      activeName: '0',
      selectList: [],
      row: {}
    }
  },
  methods: {
    select(item) {
      console.log(item)
      this.$emit('handleSelect', item, this.row.$index)
      this.toggleModal(false)
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClick() {},
    init(row, $index) {
      this.row = {
        ...row,
        $index
      }
      this.toggleModal(true)
    }
  }
}
</script>
<style lang="stylus">
.content-wrap {
  .el-tabs__content {
    // height: 400px;
  }

  .el-tag {
    cursor: pointer;
  }

  .el-tag+.el-tag {
    margin-left: 8px;
  }
}
</style>
